<div class="pb-5 px-md-5">
  <h2 class="text-info mb-4">L'État a mis en place des actions pour vous aider :</h2>
  <div class="row g-4">
    <div class="col-12 col-lg-4" *ngFor="let assistance of assistances">
      <div class="card-resource card-resource-centered">
        <span class="assistance-icon material-icons" *ngIf="assistance.icon">{{assistance.icon}}</span>
        <h3 class="card-resource-title">{{assistance.name}}</h3>
        <p class="card-resource-text text-start">{{assistance.content}}</p>
        <a class="btn btn-info text-white fw-semibold px-4 mt-auto" href="{{assistance.website}}" target="_blank" *ngIf="assistance.website">
          <span class="material-icons align-middle me-1" style="font-size: 1rem; vertical-align: -3px">open_in_new</span>
          Site web
        </a>
      </div>
    </div>
  </div>
</div>
